/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexVariantDto } from '../../models/backend-capex-variant-dto';

export interface EconomicIndicatorsCapexVariantsList$Params {
  create_date?: string;
  is_blocked?: boolean;

  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  project?: number;

  /**
   * A search term.
   */
  search?: string;
  variant_name?: string;
}

export function economicIndicatorsCapexVariantsList(
  http: HttpClient,
  rootUrl: string,
  params?: EconomicIndicatorsCapexVariantsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendCapexVariantDto>>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexVariantsList.PATH, 'get');
  if (params) {
    rb.query('create_date', params.create_date, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('ordering', params.ordering, {});
    rb.query('project', params.project, {});
    rb.query('search', params.search, {});
    rb.query('variant_name', params.variant_name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendCapexVariantDto>>;
    }),
  );
}

economicIndicatorsCapexVariantsList.PATH = '/api/economic_indicators/capex_variants/';
